
import '../assets/scss/style.scss';
import { defineComponent, reactive } from "vue";

export default defineComponent({
    name: "IntroComponentWithSignUpForm",
    data(scope) {
        const model: any = reactive({
            FirstName: "Jonathan ",
            LastName: "",
            EmailAddress: "",
            Password: ""
        });
        const validation: any = reactive({
            isValidationEnabled: false,
            isFirstNameValid: true,
            isLastNameValid: true,
            isEmailAddressValid: true,
            isPasswordValid: true,
            isValid: true
        });
        const validate = () => {
            validation.isValidationEnabled = true;
            validation.isFirstNameValid = model.FirstName !== "";
            validation.isLastNameValid = model.LastName !== "";
            validation.isPasswordValid = model.Password !== "";
            validation.isEmailAddressValid = (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(model.EmailAddress));
            validation.isValid = 
                validation.isFirstNameValid && 
                validation.isLastNameValid &&
                validation.isEmailAddressValid &&
                validation.isPasswordValid;
        }
        const clearForm = () => {
            model.FirstName = "";
            model.LastName = "";
            model.EmailAddress = "";
            model.Password = "";
            validation.isValid = true;
            validation.isFirstNameValid = true;
            validation.isLastNameValid = true;
            validation.isPasswordValid = true;
            validation.isEmailAddressValid = true;
            validation.isValidationEnabled = false;
        }
        const signup = () => {
            validate();
            if (validation.isValid) {
                alert("Thank you for registering!");
                clearForm();
            }
        }
        try {
            (scope.$refs['firstName'] as any).focus();
        } catch (ex) {
            // do nothing
        }
        return {
            model,
            validation,
            signup
        }
    }
})
